import React from 'react';
import { PreviewWithList } from 'components/common';
import { MeetingListComponent } from './MeetingList';
import { MeetingPreview } from './MeetingPreview';

interface MeetingPreviewWithListProps {
  showList: boolean;
  showPreview: boolean;
  selectedMeetingId?: number;
  selectedMeetingName?: string;
  streaming?: boolean;
  payload: object;
  onMeetingSelect: (meetingId: number, meetingName: string) => void;
  onBack: () => void;
}

export const MeetingPreviewWithList: React.FC<MeetingPreviewWithListProps> = ({
  showList,
  showPreview,
  selectedMeetingId,
  selectedMeetingName,
  streaming,
  payload,
  onMeetingSelect,
  onBack,
}) => {
  return (
    <PreviewWithList
      showList={showList}
      showPreview={showPreview}
      listComponent={
        <MeetingListComponent
          onMeetingSelect={onMeetingSelect}
          selectedMeetingId={selectedMeetingId}
        />
      }
      previewComponent={
        selectedMeetingId &&
        selectedMeetingName && (
          <MeetingPreview
            streaming={streaming}
            meetingId={selectedMeetingId}
            meetingName={selectedMeetingName}
            payload={payload}
            onBack={onBack}
          />
        )
      }
    />
  );
};
